import React, { Component } from 'react'
import * as actions from '../../actions/index'
import { connect } from 'react-redux'
import PreIngresoCalado0 from './steps/PreIngresoCalado0'
import PreIngresoCalado1 from './steps/PreIngresoCalado1'
import PreIngresoCalado2 from './steps/PreIngresoCalado2'
import ConfirmacionPreIngreso from './steps/ConfirmacionPreIngreso'
import { INTERVALO_MEDIO } from '../../../../config/settings'
import DialogoPenalizacionCamion from '../../../Camiones/components/DialogoPenalizacionCamion'
import { Dialog } from '@material-ui/core'
import moment from 'moment'
import 'moment/locale/es'

class PreIngresoCaladoA extends Component {
  constructor (props) {
    super(props)
    this.nextStep = this.nextStep.bind(this)
    this.submitPreIngreso = this.submitPreIngreso.bind(this)
    this.cancelPreIngreso = this.cancelPreIngreso.bind(this)
    this.updateCallePreIngreso = this.updateCallePreIngreso.bind(this)
    this.cargarPreIngresoCalado = this.cargarPreIngresoCalado.bind(this)
    this.updateReloadState = this.updateReloadState.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.state = { time: 0 }
  }

  handleClose () {
    this.props.dialogoPenalizacion(false)
    this.cancelPreIngreso()
  }

  nextStep () {
    this.props.preIngresoNextStep()
  }

  submitPreIngreso (numero) {
    const { callePreIngreso } = this.props
    this.props.submitPreIngresoCalado(numero, callePreIngreso)
    this.nextStep()
  }

  componentDidMount () {
    this.props.setShowFooterCalado(true)
    this.intervalReload = setInterval(() => {
      this.updateReloadState(true)
    }, INTERVALO_MEDIO)
  }

  componentWillUnmount () {
    clearInterval(this.intervalReload)
  }

  componentDidUpdate () {
    const { preIngresoStep, show } = this.props
    if (preIngresoStep !== 0) {
      this.props.setShowFooterCalado(false)
    } else {
      this.props.setShowFooterCalado(true)
    }

    if (show && preIngresoStep !== 0) {
      this.cancelPreIngreso()
      this.setState({ time: 10 })

      this.intervaloDialogo = setInterval(() => {
        if (this.state.time > 0) {
          this.setState({ time: this.state.time - 1 })
          console.log(this.state.time)
        }
        if (this.state.time === 0) {
          this.props.dialogoPenalizacion(false)
          clearInterval(this.intervaloDialogo)
        }
      }, 1000)
    }
  }

  cancelPreIngreso () {
    this.props.cancelPreIngresoCalado()
  }

  updateReloadState (newValue) {
    this.props.updateReloadState(newValue)
  }

  updateCallePreIngreso (calle) {
    this.props.updateCallePreIngreso(calle)
    this.nextStep()
  }

  cargarPreIngresoCalado (numero) {
    const { callePreIngreso } = this.props
    this.props.getDatosPreIngresoCalado(numero, callePreIngreso)
  }

  render () {
    const {
      preIngresoStep,
      callePreIngreso,
      reloadState,
      camionPenalizado,
      motivoPenalizacion,
      vencimientoPenalizacion,
      show
    } = this.props

    let vencimiento
    if (vencimientoPenalizacion) {
      vencimiento = moment(vencimientoPenalizacion).format('LLL')
    }

    return (
      <div>
        <Dialog
          open={show}
          onClose={this.handleClose}
        >
          <DialogoPenalizacionCamion camion={camionPenalizado} motivo={motivoPenalizacion} vencimiento={vencimiento} handleClose={this.handleClose} />
        </Dialog>
        {preIngresoStep === 0 && <PreIngresoCalado0 calleA={3} calleB={4} updateCallePreIngreso={this.updateCallePreIngreso} reloadState={reloadState} /> }
        {preIngresoStep === 1 && <PreIngresoCalado1 cancelPreIngreso={this.cancelPreIngreso} cargarPreIngresoCalado={this.cargarPreIngresoCalado} callePreIngreso={callePreIngreso} /> }
        {preIngresoStep === 2 && <PreIngresoCalado2 submitPreIngreso={this.submitPreIngreso} cancelPreIngreso={this.cancelPreIngreso} cpa={this.cpa} /> }
        {preIngresoStep === 3 && <ConfirmacionPreIngreso callePreIngreso={callePreIngreso} cancelPreIngreso={this.cancelPreIngreso} cpa={this.cpa} /> }
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    preIngresoStep: state.calado.preIngresoStep,
    callePreIngreso: state.calado.callePreIngreso,
    cpa: state.camionesIngreso.iCompletoCpa,
    reloadState: state.calado.reloadState,
    fotoCea: state.calado.fotoCea,
    camionPenalizado: state.camionesIngreso.camionPenalizado,
    motivoPenalizacion: state.camionesIngreso.motivoPenalizacion,
    vencimientoPenalizacion: state.camionesIngreso.vencimientoPenalizacion,
    show: state.camionesIngreso.dialogoPenalizacion
  }
}

const withRedux = connect(mapStateToProps, actions)

export default withRedux(PreIngresoCaladoA)
